<template>
  <div class="skycontent" id="aaaa">
    <div class="ssl"><div class="today">{{today}}</div>
    <div class="ssk">
      <input type="text" placeholder="请输入搜索内容..." v-model="search_text">
      <select v-model="search_select">
        <option value="0">标题</option>
        <option value="1">内容</option>
        <option value="2">全部</option>
      </select>
      <img src="../assets/images/main/ssan.png" class="sstp" @click="search()"/>
    </div>
    </div>
    <div class="skygdcd">
    <slider ref="slider" :options="options">
      <slideritem v-for="(item,index) in someList" :key="index" :style="item.style">&nbsp;</slideritem>
      <div slot="loading">图片加载中...</div>
    </slider>
    </div>

    <div class="skyxw">
      <div class="xwtpgd">
        <slider ref="slider" :options="options2">
          <slideritem v-for="(item,index) in xchlist" :key="index" :style="item.style" ></slideritem>
          <div slot="loading">图片加载中...</div>
        </slider>
      </div>

      <div class="xwgd">
        <div class="xwgdtb">
          <div id="bs1" class="xwgdtbout" @mouseover="overBs1" @click="toClsList(25)">简讯</div>
          <div id="bs2" class="xwgdtbout" @mouseover="overBs2" @click="toClsList(24)">通知</div>
<!--          <div id="bs3" class="xwgdtbout" @mouseover="overBs3" @click="toClsList(200)">疫情防控</div>-->
        </div>

        <div class="xwnr">

          <div id="tabs1">
            <ul>
              <li v-for="(article) in jxlist"><img :src="article.isnew"><a :style="{color:article.isTop}" @click="toContent(article.id,article.isreprinted)" > {{article.title|filterTitleSub(25)}}</a><span>{{article.sendtime}}</span></li>
            </ul>
            <div class="wxgd"><a href="#" @click="toClsList(25)">更多</a></div>
          </div>

          <div id="tabs2">
            <ul>
              <li v-for="(article) in tzlist"><img :src="article.isnew"><a :style="{color:article.isTop}" @click="toContent(article.id,article.isreprinted)"> {{article.title|filterTitleSub(25)}}</a><span>{{article.sendtime}}</span></li>
            </ul>
            <div class="wxgd"><a href="#"  @click="toClsList(24)">更多</a></div>
          </div>

<!--          <div id="tabs3">-->
<!--            <ul>-->
<!--              <li v-for="(article) in hyzxlist"><img :src="article.isnew"><a :style="{color:article.isTop}" @click="toContent(article.id,article.isreprinted)"> {{article.title|filterTitleSub(25)}}</a><span>{{article.sendtime}}</span></li>-->
<!--            </ul>-->
<!--            <div class="wxgd"><a href="#" @click="toClsList(200)">更多</a></div>-->
<!--          </div>-->

        </div>
      </div>
      <div class="zjtp">
        <div><a href="#" @click="toHtml('kypt')"><img src="../assets/images/main/gd1.png"/></a></div>
        <div><a href="#" @click="toClsList(160)"><img src="../assets/images/main/gd2.png"/></a></div>
        <div><a href="#" @click="toHtml('dqtd')"><img src="../assets/images/main/gd3.png"/></a></div>
        <div><a @click="toXch(1,'https://www.gdsky.com.cn/gdslsd')"><img src="../assets/images/main/gd4.jpg"/></a></div>
      </div>
    </div>
    <div class="skygdcd">
      <slider ref="slider" :options="options">
        <slideritem v-for="(item,index) in add_someList" :key="index" :style="item.style">&nbsp;</slideritem>
        <div slot="loading">图片加载中...</div>
      </slider>
    </div>
    <div class="fczz">
      <div class="wmfcm"><a href="#" @click="toClsList(170)"><img src="../assets/images/main/wmfcm.png"/></a></div>
      <div class="wmfctp">
        <div><a href="#" @click="toClsList(170)"><img src="../assets/images/main/cs1.png" height="190px" width="265px"/></a></div>
        <div class="wmfctpbt">行摄绿水青山 助力节水优先</div>
      </div>
      <div class="wmfclb">
        <ul>
          <li v-for="(article) in wmfclist"><a href="#" @click="toContent(article.id)"> {{article.title|filterTitleSub(15)}}</a></li>
        </ul>
      </div>
      <div class="wmfcm"><a href="#" @click="toClsList(176)"><img src="../assets/images/main/zyzzm.png"/></a></div>
      <div class="wmfctp">
        <div><a href="#"  @click="toClsList(176)"><img src="../assets/images/main/cs2.png"/></a></div>
        <div class="wmfctpbt">水文、水资源调查评价资质证书</div>
      </div>

      <div class="wmfclb">
        <ul>
          <li v-for="(article) in zyzzlist"><a href="#" @click="toContent(article.id)"> {{article.title|filterTitleSub(15)}}</a></li>
        </ul>
      </div>
    </div>
    <div class="kjfy">
      <a><img src="../assets/images/main/dsxt3.jpg"/></a>
    </div>
    <div class="kjfy">
      <a><img src="../assets/images/main/dsxt2.jpg"/></a>
    </div>
<!--    <div class="kjfy">-->
<!--      <a @click="toPartList(1)"><img src="../assets/images/main/dsxt.jpg"/></a>-->
<!--    </div>-->


<!--    <div class="skygdcd">-->
<!--      <slider ref="slider" :options="options3" >-->
<!--        <slideritem v-for="(item,index) in dylist" :key="index" :style="item.style"><span class="tupian"  @click="toPartList(item.id)" ></span></slideritem>-->
<!--        <div slot="loading">图片加载中...</div>-->
<!--      </slider>-->
<!--    </div>-->
    <div class="ztzl">
      <div><a href="#" @click="toClsList(171)"><img src="../assets/images/main/zt1.png"/></a></div>
      <div><a href="#" @click="toClsList(162)"><img src="../assets/images/main/zt2.png"/></a></div>
      <div><a href="#" @click="toClsList(178)"><img src="../assets/images/main/zt3.png"/></a></div>
      <div><a href="#" @click="toClsList(168)"><img src="../assets/images/main/zt4.png"/></a></div>
      <div><img src="../assets/images/main/zt5.png"/></div>
    </div>

<!--    <div class="kjfy">-->
<!--      <a href="http://slt.gd.gov.cn/zthg/2020nzt/zzccfkyq/"><img src="../assets/images/main/fybqxcp.jpg"></a>-->
<!--    </div>-->
    <div class="wzdh">
      <select id="slbm" v-on:change="webLink($event)">
        <option value ="0">-------------水利部门网站-------------</option>
        <option value ="http://www.mwr.gov.cn/">水利部</option>
        <option value ="http://slt.gd.gov.cn/">广东水利厅</option>
        <option value ="http://slt.gd.gov.cn/zsdw_2021/gdsswj/">水文局</option>
        <option value ="http://slt.gd.gov.cn/zsdw_2021/djlyglj/">东江流域管理局</option>
        <option value ="http://slt.gd.gov.cn/zsdw_2021/xjly/">西江流域管理局</option>
        <option value ="http://slt.gd.gov.cn/zsdw_2021/bjlyj/">北江流域管理局</option>
        <option value ="http://slt.gd.gov.cn/zsdw_2021/hjly/">韩江流域管理局</option>
        <option value ="http://www.gpdiwe.com/">水利电力规划勘测设计研究院</option>
      </select>
      <select id="gdzf" v-on:change="webLink($event)">
        <option value ="0">-------------广东政府网站-------------</option>
        <option value ="http://www.gd.gov.cn/">省府办公厅</option>
        <option value ="http://gdstc.gd.gov.cn/">省科技厅</option>
        <option value ="http://gdga.gd.gov.cn/">省公安厅</option>
        <option value ="http://czt.gd.gov.cn/">省财政厅</option>
        <option value ="http://drc.gd.gov.cn/">省发展改革委</option>
        <option value ="http://gdii.gd.gov.cn/">省工业和信息化厅</option>
        <option value ="http://smzt.gd.gov.cn/">省民政厅</option>
        <option value ="http://hrss.gd.gov.cn/">省人力资源社会保障厅</option>
      </select>
      <select id="xwmt" v-on:change="webLink($event)">
        <option value ="0">-------------新闻媒体网站-------------</option>
        <option value ="http://www.peopledaily.com.cn/">人民日报</option>
        <option value ="http://www.chinadaily.com.cn/">中国日报</option>
        <option value ="http://www.gmw.cn/">光明日报</option>
        <option value ="http://www.peopledaily.com.cn/">人民网</option>
        <option value ="http://www.xinhuanet.com/">新华网</option>
        <option value ="http://www.chinanews.com/">中国新闻网</option>
        <option value ="http://www.chinawater.com.cn/">中国水利网</option>
        <option value ="http://www.southcn.com/">南方日报</option>
      </select>
    </div>
  </div>
</template>

<script>
    import { slider, slideritem } from 'vue-concise-slider'
    export default {
        name: "mainPage",
        data(){
            return{
                jxlist:'',//简讯
                tzlist:'',//通知
                hyzxlist:'',//行业资讯
                wmfclist:'',//文明风采
                zyzzlist:'',//专业资质
                search_text:'',//搜索内容
                search_select:0,//搜索类型
                today:'',
                someList:[
                    {html: '1', style: {background: 'url(../gdskykcsjy/static/images/main/1.jpg)'}},
                    {html: '2', style: {background: 'url(../gdskykcsjy/static/images/main/2.jpg)'}},
                    {html: '3', style: {background: 'url(../gdskykcsjy/static/images/main/3.jpg)'}},

                ],
                xchlist:[
                  {html: '1', style: {background: 'url(../gdskykcsjy/static/images/main/sjy1.jpg)'}},
                  {html: '2', style: {background: 'url(../gdskykcsjy/static/images/main/sjy2.jpg)'}},
                  {html: '3', style: {background: 'url(../gdskykcsjy/static/images/main/sjy3.jpg)'}},
                  {html: '4', style: {background: 'url(../gdskykcsjy/static/images/main/sjy4.jpg)'}},
                ],
                add_someList:[
                  {html: '1', style: {background: 'url(../gdskykcsjy/static/images/main/add_11.jpg)'}},
                  {html: '2', style: {background: 'url(../gdskykcsjy/static/images/main/add_12.jpg)'}},
                  {html: '3', style: {background: 'url(../gdskykcsjy/static/images/main/add_13.jpg)'}},
                  {html: '4', style: {background: 'url(../gdskykcsjy/static/images/main/add_14.jpg)'}},
                  {html: '4', style: {background: 'url(../gdskykcsjy/static/images/main/add_15.jpg)'}},
                  {html: '4', style: {background: 'url(../gdskykcsjy/static/images/main/add_16.jpg)'}},
                ],
                dylist:[
                  {html: '1', id: '1', style: {background: 'url(../gdskykcsjy/static/images/main/dsxt.jpg)'}},
                  {html: '2', id: '2',style: {background: 'url(../gdskykcsjy/static/images/main/dsxt2.jpg)'}},
                  {html: '3', id: '3',style: {background: 'url(../gdskykcsjy/static/images/main/dsxt3.jpg)'}},
                ],
                options: {
                    currentPage: 0,//当前页码
                    thresholdDistance: 500,//滑动判定距离
                    thresholdTime: 1000,//滑动判定时间npm
                    autoplay:6000,//自动滚动[ms]
                    // loop:true,//循环滚动
                    loop:true,//循环滚动
                    direction:'horizontal',//方向设置，垂直滚动
                    loopedSlides:1,//无限滚动前后遍历数
                    slidesToScroll:1,//每次滑动项数
                    pagination: false
                },

                options2: {
                    currentPage: 0,//当前页码
                    thresholdDistance: 300,//滑动判定距离
                    thresholdTime: 1000,//滑动判定时间
                    autoplay:7000,//自动滚动[ms]
                    loop:true,//循环滚动
                    direction:'vertical',//方向设置，垂直滚动
                    loopedSlides:1,//无限滚动前后遍历数
                    slidesToScroll:1,//每次滑动项数
                    pagination: true,

                },
                options3: {
                  currentPage: 0,//当前页码
                  thresholdDistance: 500,//滑动判定距离
                  thresholdTime: 1000,//滑动判定时间npm
                  autoplay:5000,//自动滚动[ms]
                  // loop:true,//循环滚动
                  loop:true,//循环滚动
                  direction:'horizontal',//方向设置，垂直滚动
                  loopedSlides:1,//无限滚动前后遍历数
                  slidesToScroll:1,//每次滑动项数
                  pagination: false
                }
            }
        },
        components: {
            slider,
            slideritem
        },
        mounted(){
            this.getArticle();
            let myDate = new Date();
            let year=myDate.getFullYear();    //获取完整的年份(4位,1970-????)
            let month=myDate.getMonth()+1;       //获取当前月份(0-11,0代表1月)
            let date=myDate.getDate();        //获取当前日(1-31)
            let str = "星期" + "日一二三四五六".charAt(new Date().getDay())
            this.today='今天是'+year+'年'+month+'月'+date+'日 '+str;
        },
        filters:{
            filterTitleSub:function (title,long) {
              if(title.length>long){
                  title=title.substring(0,long)+'...';
              }
              return title;
            }
        },
        methods:{
            getArticle(){
                this.axios.get('/mainweb/index').then(res =>{
                    this.jxlist=this.isNew(res.data.jx);
                    this.tzlist=this.isNew(res.data.tz);
                    this.hyzxlist=this.isNew(res.data.hyzx);
                    this.wmfclist=res.data.wmfc;
                    this.zyzzlist=res.data.zyzz;
                    if(res.data.islan){
                        this.$parent.changeIslan(true);
                    }
                });
            },
            isNew(list){
                for(let i=0;i<list.length;i++){
                  let date=new Date(list[i].sendtime);
                  let now=new Date();
                  let day=(now-date)/1000/60/60/24;
                  if(parseInt(day)<3){
                      list[i].isnew='/admin/attachments/month_1910/new.gif';
                  }else {
                      list[i].isnew='/admin/attachments/month_1910/arrow.jpg';
                  }
                  if(list[i].isTop==0){
                    list[i].isTop=''
                  }else{
                    list[i].isTop='#FF0000'
                  }
                }
                return list;
            },

            toClsList(id){
                this.$parent.changeClsList(id);
            },
            toHtml(com){
                this.$parent.changeHtml(com)
            },
            webLink(event){
                if(event.target.value!='0'){
                    window.open(event.target.value);
                }
            },
            search(){
              if(!this.search_text.match(/^[(\u4e00-\u9fa5)|(0-9)]+$/)){
                  alert("只能输入数字和中文！！");
              }else if(this.search_text.length<2){
                  alert("搜索必须大于两个字符");
              }else {
                  this.$parent.toSearch(this.search_select,this.search_text,1);
              }
            },
          toPartList(id){
              this.toTop();//置顶
              if (id==1) {
                this.$router.push('/dyindex');
              }else if(id==2){
                this.$router.push('/dyindex2');
              }else if(id==3){
                this.$router.push('/dyindex3');
              }else {
                alert("无此页面！");
              }

          },

            overBs1(){
                document.getElementById("tabs1").style.display='block';
                document.getElementById("bs1").classList.add('xwgdtover');
                document.getElementById("bs1").classList.remove('xwgdtbout');
                document.getElementById("bs1").style.background='url(../gdskykcsjy/static/images/main/xegdtb2.png)';
                document.getElementById("tabs2").style.display='none';
                document.getElementById("bs2").classList.add('xwgdtbout');
                document.getElementById("bs2").classList.remove('xwgdtover');
                document.getElementById("bs2").style.background='url(../gdskykcsjy/static/images/main/xegdtb1.png)';
                // document.getElementById("tabs3").style.display='none';
                // document.getElementById("bs3").classList.add('xwgdtbout');
                // document.getElementById("bs3").classList.remove('xwgdtover');
                // document.getElementById("bs3").style.background='url(../gdskykcsjy/static/images/main/xegdtb1.png)';
            },
            overBs2(){
                document.getElementById("tabs2").style.display='block';
                document.getElementById("bs2").classList.add('xwgdtover');
                document.getElementById("bs2").classList.remove('xwgdtbout');
                document.getElementById("bs2").style.background='url(../gdskykcsjy/static/images/main/xegdtb2.png)';
                document.getElementById("tabs1").style.display='none';
                document.getElementById("bs1").classList.add('xwgdtbout');
                document.getElementById("bs1").classList.remove('xwgdtover');
                document.getElementById("bs1").style.background='url(../gdskykcsjy/static/images/main/xegdtb1.png)';
                // document.getElementById("tabs3").style.display='none';
                // document.getElementById("bs3").classList.add('xwgdtbout');
                // document.getElementById("bs3").classList.remove('xwgdtover');
                // document.getElementById("bs3").style.background='url(../gdskykcsjy/static/images/main/xegdtb1.png)';
            },
            // overBs3(){
            //     document.getElementById("tabs3").style.display='block';
            //     document.getElementById("bs3").classList.add('xwgdtover');
            //     document.getElementById("bs3").classList.remove('xwgdtbout');
            //     document.getElementById("bs3").style.background='url(../static/images/main/xegdtb2.png)';
            //     document.getElementById("tabs1").style.display='none';
            //     document.getElementById("bs1").classList.add('xwgdtbout');
            //     document.getElementById("bs1").classList.remove('xwgdtover');
            //     document.getElementById("bs1").style.background='url(../static/images/main/xegdtb1.png)';
            //     document.getElementById("tabs2").style.display='none';
            //     document.getElementById("bs2").classList.add('xwgdtbout');
            //     document.getElementById("bs2").classList.remove('xwgdtover');
            //     document.getElementById("bs2").style.background='url(../static/images/main/xegdtb1.png)';
            // },
            open(id) {
              this.$confirm('您访问的链接即将离开“广东水科院勘测设计院”门户网站 确认继续？', '是否跳转到外部链接...', {
                distinguishCancelAndClose: false,
                confirmButtonText: '继续访问',
                cancelButtonText: '放弃'
              }).then(() => {
                  this.axios.get('/mainweb/content?ID='+id).then(res =>{
                    if(res.data.id==0){
                      alert(res.data.msg);
                    }else {
                        window.open(res.data.content.replace(/<.+?>/g, ''),'_blank');
                    }
                  });

                })
                .catch(action => {

                });
            },
            toContent(id,isreprinted){
              if (isreprinted==true){
                this.open(id);
              // }else if (id==-1){
              //   window.open(sender,'_blank');
              }else{
                this.$parent.changeContent(id);
              }
            },
            toTop() {       //页面置顶
              window.scrollTo({ top: 0 });
            },

            toXch(isreprinted,content){
              if (isreprinted){
                this.$confirm('您访问的链接即将离开“广东水科院勘测设计院”门户网站 确认继续？', '是否跳转到外部链接...', {
                  distinguishCancelAndClose: false,
                  confirmButtonText: '继续访问',
                  cancelButtonText: '放弃'
                }).then(() => {
                  window.open(content.replace(/<.+?>/g, ''),'_blank');
                })
                  .catch(action => {
                  });
              }else if (isreprinted==-1){
                window.open(content,'_blank');
              }else{

                this.$parent.changeContent(content);
              }
            }
        }
    }

</script>

<style scoped>
  @import '../assets/css/main/mainPage.css';
  .today{
    width: 400px;
    margin:8px 10px 8px 10px;
    height: 30px;
    /*border:1px solid #000000;*/
    float: left;
  }
  .kjfy{
    width: 1230px;
    height: 130px;
    border:1px solid #000000;
    margin:18px auto 20px auto;
  }
  .tupian{
    width: 630px;
    height: 400px;
  }
  #top{
    position:absolute;
    top:0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/mainPage.vue